import React from "react";
import LandingPage from "./Components/LandingPage";
import LandingPageNew from "./Components/LandingPageNew";
import LandingPageNew2 from "./Components/LandingPageNew2";


import AnalysisLandingPage from "./Components/AnalysisLandingPage";
import SelexRiskLandingPage from "./Components/SelexRiskLandingPage";

import MathLandingPage from "./Components/MathLandingPage";

import NewProject from "./Components/NewProject";
import Blogs from "./Components/Blogs";
import BlogPreview from "./Components/BlogPreview";
import ReviewBlogs from "./Components/ReviewBlogs";
import ReviewBlogPreview from "./Components/ReviewBlogPreview";

import Projects from "./Components/Projects";
import ProjectsPreview from "./Components/ProjectsPreview";

import Importcsv from "./Components/Pages/Importcsv";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./Components/Login";
import BusinessLogin from "./Components/BusinessLogin";

import Level3Login from "./Components/Level3Login";

import Select from "./Components/Select";
import SelectSelexMath from "./Components/SelectSelexMath";
import SelectSelexRisk from "./Components/SelectSelexRisk";
import OptimizeXP from "./Components/OptimizeXP";
import DesktopUser from "./Components/DesktopUser";


import Admin from "./Components/Admin/Admin";
import AdminHome from "./Components/Admin/AdminHome";
import Desktopdashboard from "./Components/Admin/Desktopdashboard";


import FirstPage from "./Components/FirstPage";
import About from "./Components/About";
import { ProtectedRoute,AdminRoute } from "./Helpers/route";
import ForgotPassword from "./Components/Pages/ForgotPassword";
import ForgotPasswordAdmin from "./Components/Pages/ForgotPasswordAdmin";
import Help from "./Components/Help"
import GPT from "./Components/GPT";
import SelexSIM from "./Components/SelexSIM";
import SelexHelp from "./Components/SelexHelp";
import SelexRiskHelp from "./Components/SelexRiskHelp";

import SelexAnalysis from "./Components/SelexAnalysis";
import SelexFCC from "./Components/SelexFCC";
import SelexHybrid from "./Components/SelexHybrid";
import SelexOracle from "./Components/SelexOracle";


import SelexMSD from "./Components/SelexMSD";


import SelexRisk from "./Components/SelexRisk";
import SelexPulseNew from "./Components/SelexPulseNew";
import TCP from "./Components/TCP";
import AboutPage from "./Components/AboutPage";
import AdminBlog from "./Components/Admin/AdminBlog"
import AdminAddBlog from "./Components/Admin/AdminAddBlog"
import AddNewsletter from "./Components/Admin/AddNewsLetter"
import EditNewsletter from "./Components/Admin/EditNewsLetter"

import PreviewNewsletter from "./Components/Admin/PreviewNewsLetter"


import AdminEditBlog from "./Components/Admin/AdminEditBlog";
import Maintanance from "./Components/Maintanance";
import AdminAddProject from "./Components/Admin/AdminAddProject";
import AdminEditproject from "./Components/Admin/AdminEditProject";
import SelexSimLanding from "./Components/SelexSIMLanding";
import SelexMBLanding from "./Components/SelexMBLanding";
import SelexStudio from "./Components/SelexStudio";
import SelexStudioEight from "./Components/SelexStudioEight";
import SelexStudioSix from "./Components/SelexStudioSix.js";

import SelexStudioThree from "./Components/SelexStudioThree";
import SelexMBExplorer from "./Components/SelexMBExplorer";
import SelexMBExplorerXP from "./Components/SelexMBExplorerXP";

import SelexMBExplorerXPFP from "./Components/SelexMBExplorerXPFP";

import SelexMBExplorerXFP from "./Components/SelexMBExplorerXFP";

import SelexCAM from "./Components/SelexCAM";
import SelexECA from "./Components/SelexECA";
import SelexFZ from "./Components/SelexFZ";
import SelexREF from "./Components/SelexREF";
import SelexRXN from "./Components/SelexRXN";
import SelexSRU from "./Components/SelexSRU";
import SelexWell from "./Components/SelexWell.js";
import SelexCIP from "./Components/SelexCIP.js";
import SelexRS from "./Components/SelexRS.js";
import CADENCE from "./Components/Cadence.js";
import BusinessApps from "./Components/BusinessApps";
import SelexPlanner from "./Components/SelexPlanner";













function App() {
  const token = sessionStorage.getItem("usertoken");
  const [admin, setAdmin] = React.useState(false);
  const [userToken, setUserToken] = React.useState("");
  const [level3Token, setlevel3Token] = React.useState("");

  const checkAdminRole = (value) => {
    setAdmin(value)
    sessionStorage.setItem("adminlogin", admin);
  };

  const handleNavigate =async (token)=>{
    setUserToken(token)
    sessionStorage.setItem("usertoken", token);
  

  }

   
  
  return (
    <Router>
      <div className="App">

        <Routes>
          <Route exact path="/" element={<LandingPageNew2 isLoggedIn={!!sessionStorage.getItem("usertoken")}/>} />
          <Route exact path="/new" element={<LandingPageNew />} />
           <Route exact path="/firstpage" element={<FirstPage />} />
          <Route exact path="/maintenance" element={<Maintanance />} />
          <Route exact path="/about" element={<About />} />
          <Route exact path="/aboutpage" element={<AboutPage />} />
          <Route exact path="/select" element={<Select />} />
          <Route exact path="/selectselexsim" element={<SelectSelexMath />} />
          <Route exact path="/selexsimlanding" element={<SelexSimLanding />} />
          <Route exact path="/selexmblanding" element={<SelexMBLanding />} />
           <Route exact path="/optimizexp2" element={<OptimizeXP isLoggedIn={!!sessionStorage.getItem("usertoken")}/>} />

          <Route exact path="/selectselexrisk" element={<SelectSelexRisk />} />
          <Route exact path="/selexsim" element={<SelexSIM />} />
          
           <Route path="/blogs" element={<Blogs/>} />
            <Route path="/reviewblogs" element={<ReviewBlogs/>} />
            <Route path="/blog/:slug" element={<BlogPreview/>} />
            <Route path="/reviewblog/:slug" element={<ReviewBlogPreview/>} />
            <Route path="/landingpageexample" element={<LandingPageNew/>} />
            <Route path="/allprojects" element={<Projects/>} />
            <Route path="/projects/:slug" element={<ProjectsPreview/>} />




          <Route exact path="/login" element={<Login handleNavigate={handleNavigate} />} />
           <Route exact path="/businessuserlogin" element={<BusinessLogin  handleNavigate={handleNavigate}/>} />
          <Route exact path="/level3/login" element={<Level3Login  />} />

          <Route exact path="/forgotpassword" element={<ForgotPassword />} />
          <Route exact path="/forgotpassword/:id" element={<ForgotPassword />} />
          <Route exact path="/forgotpasswordadmin" element={<ForgotPasswordAdmin />} />
          <Route exact path="/forgotpasswordadmin/:id" element={<ForgotPasswordAdmin />} />
          <Route path="/admin" element={<Admin checkAdminRole={checkAdminRole} />} />
          <Route
            path="adminhome"
            element={
              <AdminRoute admin={admin}>
                <AdminHome />
              </AdminRoute>
            }
          />
            <Route path="/admin/blogs/add" element={<AdminAddBlog/>}/>
            <Route path="/admin/projects/add" element={<AdminAddProject/>}/>
            <Route path="/admin/blogs/edit/:blog_id" element={<AdminEditBlog/>} />
            <Route path="/admin/projects/edit/:project_id" element={<AdminEditproject/>} />
            <Route path="/admin/level3/dashboard" element={<Desktopdashboard/>}/>
            <Route path="/desktop-downloads" element={<DesktopUser />} />
            <Route
  path="/admin/newsletter/add"
  element={<AddNewsletter />}
/>

<Route
  path="/admin/newsletter/edit/:id"
  element={<EditNewsletter />}
/>

<Route
  path="/admin/newsletter/preview/:id"
  element={<PreviewNewsletter />}
/>



          <Route element={<ProtectedRoute user={token || userToken} />}>
            <Route path="/home" element={<NewProject />} />
            <Route path="/newproject" element={<LandingPage />} />
            <Route path="/newmathproject" element={<MathLandingPage />} />
            <Route path="/newanalysisproject" element={<AnalysisLandingPage />} />
            <Route path="/newselexriskproject" element={<SelexRiskLandingPage />} />
            <Route path="/selexsim/selexstudio2" element={<SelexStudio />} />
            <Route path="/selexsim/selexstudio/v2-6xp" element={<SelexStudioSix />} />
            <Route path="/selexsim/selexstudio/v2-8xp" element={<SelexStudioEight />} />
            <Route path="/selexsim/selexstudio/v3-0xp" element={<SelexStudioThree />} />


            <Route path="/selexstudio2" element={<SelexStudio />} />
            <Route path="/selexstudio/v2-6xp" element={<SelexStudioSix />} />
            <Route path="/selexstudio/v2-8xp" element={<SelexStudioEight />} />
            <Route path="/selexstudio/v3-0xp" element={<SelexStudioThree />} />
            


             <Route path="/selexmbexplorer" element={<SelexMBExplorerXFP />} />
            <Route path="/selexmbexplorer/v2-6xp" element={<SelexMBExplorerXP />} />
            <Route path="/selexmbexplorer/v2-6xpfp" element={<SelexMBExplorerXPFP />} />
            <Route path="/selexmbexplorer/v2-6xfp" element={<SelexMBExplorerXFP />} />
             <Route path="/selexcam2" element={<SelexCAM />} />
             <Route path="/selexeca" element={<SelexECA />} />
            <Route path="/selexfz" element={<SelexFZ />} />
             <Route path="/selexref" element={<SelexREF />} />
             <Route path="/selexrxn" element={<SelexRXN />} />
              <Route path="/selexsru" element={<SelexSRU />} />
              <Route path="/selexwell" element={<SelexWell />} />
              <Route path="/selexoracle" element={<SelexOracle />} />
              <Route path="/selexcip" element={<SelexCIP />} />
              <Route path="/selexrs" element={<SelexRS />} />
              <Route path="/cadence" element={<CADENCE />} />
              <Route path="/businessapps" element={<BusinessApps onLogout={() => setUserToken(null)} />} />
                <Route path="/selexplanner" element={ <SelexPlanner /> } />


             <Route path="/selexanalysis" element={<SelexAnalysis />} />
           <Route path="/selexfcc" element={<SelexFCC />} />
             <Route path="/selexmsd" element={<SelexMSD />} />
          <Route exact path="/selexrisk" element={<SelexRisk />} />
          <Route exact path="/selexpulse2" element={<SelexPulseNew />} />
          <Route exact path="/selexhybrid" element={<SelexHybrid />} />



            <Route path="/importcsv" element={<Importcsv />} />
            <Route path="/help" element={<Help />} />
            <Route path="/selexsim-help" element={<SelexHelp />} />
            <Route path="/selexrisk-help" element={<SelexRiskHelp />} />

            <Route path="/gpt" element={<GPT />} />
            <Route path="/tcpserver" element={<TCP />} />
           
            
          </Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;

